import Vue from 'vue';
import VueLazyDirective from '../directives/v-lazy';

import EventBus from '../vue/bus';

import CtaButton from '../vue/CtaButton.vue';
import VideoPlayButton from '../vue/VideoPlayButton.vue';
import TestimonialModalVideo from '../vue/TestimonialModalVideo.vue';

export default function(el) {
  if (el === null) return false;
  new Vue({
    el,
    delimiters: ['${', '}'],
    directives: {
      lazy: VueLazyDirective,
    },
    components: {
      CtaButton,
      VideoPlayButton,
      TestimonialModalVideo,
    },
    props: {
      testimonials: {
        type: Array,
        default() {
          return JSON.parse(el.dataset.testimonials);
        },
      },
    },
    data() {
      return {
        ready: false,
        currentTestimonial: 1,
      };
    },
    computed: {
      totalTestimonials() {
        return this.testimonials.length;
      },
      isFirstTestimonial() {
        return this.currentTestimonial === 1;
      },
      isLastTestimonial() {
        return this.currentTestimonial === this.totalTestimonials;
      },
      nextTestimonial() {
        if (!this.isLastTestimonial) {
          return this.currentTestimonial + 1;
        } else {
          return 1;
        }
      },
      landscape() {
        return (
          this.testimonials[this.currentTestimonial - 1].layout === 'landscape'
        );
      },
      previousTestimonial() {
        if (!this.isFirstTestimonial) {
          return this.currentTestimonial - 1;
        } else {
          return this.totalTestimonials;
        }
      },
      currentTestimonialData() {
        return this.testimonials[this.currentTestimonial - 1];
      },
    },
    mounted() {
      this.ready = true;
      this.cleanUpData();
    },
    methods: {
      cleanUpData() {
        Object.keys(this.$el.dataset).forEach(dataKey => {
          delete this.$el.dataset[dataKey];
        });
      },
      handleSwiperButtonClick(direction) {
        if (direction === 'next') {
          this.currentTestimonial = this.nextTestimonial;
        } else if (direction === 'previous') {
          this.currentTestimonial = this.previousTestimonial;
        }
      },
      videoClickHandler() {
        this.videoId = this.currentTestimonialData.modalVideoId;
        this.videoProvider = this.currentTestimonialData.modalProvider;
        EventBus.$emit(EventBus.TESTIMONIAL_VIDEO_CLICK);
      },
    },
  });
}
